import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "access-key-block" }
const _hoisted_2 = { class: "g-row g-row--justify_center g-row--justify_between-xl g-row--appearance_spaced g-row--space_md" }
const _hoisted_3 = { class: "g-cell g-cols g-cols--narrow" }
const _hoisted_4 = { class: "access-key-qr-code" }
const _hoisted_5 = { class: "g-cell g-cols g-cols--12 g-cols--7-xl" }
const _hoisted_6 = { class: "access-key-content" }
const _hoisted_7 = { class: "access-key-content__title" }
const _hoisted_8 = { class: "ds-caption ds-caption--bold ds-caption--size_3xl ds-caption--size_5xl-xl ds-caption--color_dark-blue ds-caption--appearance_center-till-xl" }
const _hoisted_9 = { class: "access-key-content__subtitle" }
const _hoisted_10 = { class: "ds-caption ds-caption--medium ds-caption--size_2md ds-caption--color_dark-blue ds-caption--appearance_center-till-xl" }
const _hoisted_11 = { class: "access-key-content__key-access" }
const _hoisted_12 = { class: "output-block output-block--key-access relative" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "output-block__img" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: "/static/app/copy-icon.svg",
  alt: "copy icon",
  title: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_qr_code = _resolveComponent("qr-code")!
  const _component_copy_to_clip_board = _resolveComponent("copy-to-clip-board")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_qr_code, {
            "qr-code": $setup.props.user_key
          }, null, 8, ["qr-code"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString($setup.$t('Ваш ключ доступа')), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, _toDisplayString($setup.$t('Scan or Enter code')), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("input", {
                class: "output output--style_main relative",
                value: $setup.props.user_key,
                type: "text"
              }, null, 8, _hoisted_13),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_copy_to_clip_board, {
                  text: $setup.props.user_key,
                  centered: true
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }, 8, ["text"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}